import AlgoliaEvent from './AbstractEvent';

class AddToCartAfterSearch extends AlgoliaEvent {
  algoliaEvent = 'addedToCartObjectIDsAfterSearch';

  customEventName = 'add_to_card_after_search';
}

export default AddToCartAfterSearch;
